/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import { Card } from '@veneer/core';
import React, { memo } from 'react';
import './styles.scss';
import { GenericCardContainerProps } from './types';
import { generateID } from '../../base/helper';

/**
 * UI Toolkit Generic Card component based on Veneer Card
 * @public
 */
const Container: React.FC<GenericCardContainerProps> = ({
  id = generateID('clientos-ui-toolkit-generic-card'),
  children,
  onClick
}) => {
  return (
    <Card
      id={id}
      appearance="outlined"
      className={`clientos-ui-toolkit-generic-card ${onClick ? 'clientos-ui-toolkit-generic-card--clickable' : ''}`}
      content={
        <div
          className="clientos-ui-toolkit-generic-card__content"
          id={`${id}__content`}
        >
          {children}
        </div>
      }
      onClick={onClick}
    />
  );
};
export default memo(Container);
